export enum EmailTemplateType {
  ReportEmail = 0,
  NotificationEmail = 1,
}
